var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0094 8.53123L6.75938 12.7812C6.46563 13.075 5.99063 13.075 5.7 12.7812L4.99375 12.075C4.7 11.7812 4.7 11.3062 4.99375 11.0156L8.00625 8.0031L4.99375 4.9906C4.7 4.69685 4.7 4.22185 4.99375 3.93123L5.69687 3.21873C5.99062 2.92498 6.46562 2.92498 6.75625 3.21873L11.0062 7.46873C11.3031 7.76248 11.3031 8.23748 11.0094 8.53123Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.271ed13f041dc1dae3732a08cc33ccfc.svg";
export { ForwardRef as ReactComponent };